/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_LOADED_MODEL_NAME = "SET_LOADED_MODEL_NAME";
export const SET_MODEL_BY_SIZE = "SET_MODEL_BY_SIZE";

export const SAVE_DEFAULT_TEXTURES = "SAVE_DEFAULT_TEXTURES";